import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {PublicClientApplication} from "@azure/msal-browser";
import {msalConfig} from "./component/auth/authConfig";
import { userActivityLogout } from './utils/userActivityLogout';

export const msalInstance: PublicClientApplication = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
const AppWithUserInactivity = userActivityLogout(App);
root.render(
    <React.StrictMode>
            <AppWithUserInactivity msalInstance={msalInstance}/>
    </React.StrictMode>
);
